export const projects = [
  {
    id: 1,
    name: "Kurumsal Ağ ve Veri Merkezi Altyapısı",
    location: "Finans Sektörü · Ankara",
    units: 450,
    status: "Tamamlandı",
    statusColor: "completed",
    year: "2023",
    area: "3 Lokasyon",
    type: "Ağ & Altyapı",
    description: "Üç ayrı lokasyonda faaliyet gösteren bir finans kuruluşu için uçtan uca ağ ve veri merkezi altyapısı kurduk. Yapısal kablolama, çekirdek anahtarlama, yedekli internet ve felaket kurtarma altyapısı ile kesintisiz operasyon sağlandı.",
    features: ["Yapısal Kablolama", "Çekirdek Switch", "Sunucu & Depolama", "Yedekli İnternet", "Felaket Kurtarma"],
    image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=800&q=80"
  },
  {
    id: 2,
    name: "Çok Katmanlı Siber Güvenlik Projesi",
    location: "Üretim Sektörü · İstanbul",
    units: 600,
    status: "Tamamlandı",
    statusColor: "completed",
    year: "2023",
    area: "Endpoint + Ağ",
    type: "Siber Güvenlik",
    description: "600 uç noktaya sahip bir üretim firmasında uç noktadan ağ katmanına kadar çok katmanlı güvenlik mimarisi devreye aldık. Yeni nesil güvenlik duvarı, EDR/XDR ve SIEM tabanlı sürekli izleme ile siber tehditlere karşı tam koruma sağlandı.",
    features: ["Next-Gen Firewall", "EDR / XDR", "SIEM İzleme", "E-posta Güvenliği", "Sızma Testi"],
    image: "https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?auto=format&fit=crop&w=800&q=80"
  },
  {
    id: 3,
    name: "Microsoft 365 ve Bulut Göçü",
    location: "Hizmet Sektörü · Ankara",
    units: 320,
    status: "Tamamlandı",
    statusColor: "completed",
    year: "2024",
    area: "Bulut",
    type: "Bulut Çözümleri",
    description: "320 kullanıcılı bir kurumun e-posta ve dosya altyapısını Microsoft 365'e taşıdık. Exchange Online, SharePoint ve OneDrive geçişi, çok faktörlü kimlik doğrulama ve bulut yedekleme ile güvenli ve modern bir çalışma ortamı oluşturuldu.",
    features: ["M365 Geçişi", "Exchange Online", "SharePoint", "Bulut Yedekleme", "MFA Güvenliği"],
    image: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=800&q=80"
  },
  {
    id: 4,
    name: "Yönetilen BT Hizmetleri (7/24)",
    location: "Perakende Zinciri · Türkiye Geneli",
    units: 1200,
    status: "Devam Ediyor",
    statusColor: "ongoing",
    year: "2025",
    area: "40 Şube",
    type: "Yönetilen Hizmet",
    description: "40 şubeli bir perakende zincirinin tüm BT operasyonunu 7/24 yönetilen hizmet modeliyle üstleniyoruz. Uzaktan izleme, yardım masası, saha desteği ve SLA garantili çözüm süreleriyle binlerce uç nokta kesintisiz yönetiliyor.",
    features: ["7/24 İzleme", "Yardım Masası", "SLA Garantisi", "Saha Desteği", "Envanter Yönetimi"],
    image: "https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&w=800&q=80"
  },
  {
    id: 5,
    name: "Toplantı Odası ve Görüntülü İletişim Çözümü",
    location: "Kamu Kurumu · Ankara",
    units: 85,
    status: "Tamamlandı",
    statusColor: "completed",
    year: "2022",
    area: "12 Salon",
    type: "Görüntülü İletişim",
    description: "Bir kamu kurumunun 12 toplantı salonunu uçtan uca görüntülü iletişim altyapısıyla donattık. Video konferans sistemleri, akıllı tahtalar, profesyonel ses çözümleri ve merkezi uzaktan yönetim ile hibrit çalışmaya tam uyum sağlandı.",
    features: ["Video Konferans", "Akıllı Tahta", "Profesyonel Ses Sistemi", "Uzaktan Yönetim", "Merkezi Kontrol"],
    image: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?auto=format&fit=crop&w=800&q=80"
  },
  {
    id: 6,
    name: "Felaket Kurtarma ve İş Sürekliliği",
    location: "Sağlık Sektörü · İzmir",
    units: 0,
    status: "Planlama",
    statusColor: "planning",
    year: "2026",
    area: "2 Veri Merkezi",
    type: "İş Sürekliliği",
    description: "Bir sağlık kuruluşu için iki veri merkezi arasında çalışan felaket kurtarma ve iş sürekliliği çözümü tasarlıyoruz. Gerçek zamanlı replikasyon, otomatik yük devretme ve düşük RTO/RPO hedefleriyle kritik sistemlerin kesintisiz çalışması güvence altına alınıyor.",
    features: ["DR Site", "Replikasyon", "Otomatik Yük Devretme", "Yedekleme", "RTO / RPO Optimizasyonu"],
    image: "https://images.unsplash.com/photo-1544197150-b99a580bb7a8?auto=format&fit=crop&w=800&q=80"
  }
];

export const projectStats = [
  { value: "500+", label: "Tamamlanan Proje" },
  { value: "10+", label: "Yıllık Tecrübe" },
  { value: "7/24", label: "Teknik Destek" },
  { value: "%99.9", label: "Sistem Sürekliliği" }
];
